<template>
  <div class="columns is-multiline filtros-licitacoes-row">
    <div class="column filtros-licitacoes__campo is-12-mobile is-6-tablet is-2-desktop">
      <FiltroMultiSelect
        label="Situação"
        :options="situacoes"
        :value="filters.situacaoIds"
        @input="update('situacaoIds', $event)"
        @commit="commit"
        @open="$emit('open')"
        @close="$emit('close')"
      />
    </div>
    <div class="column filtros-licitacoes__campo is-12-mobile is-6-tablet is-3-desktop">
      <FiltroMultiSelect
        label="Unidade de compra"
        :options="purchasingUnitOptions"
        :value="selectedUnitFilterValues"
        :loading="purchasingUnitsLoading"
        @input="updateUnitFilters"
        @commit="commit"
        @open="$emit('open')"
        @close="$emit('close')"
      />
    </div>
    <div class="column filtros-licitacoes__campo is-12-mobile is-6-tablet is-2-desktop">
      <DateRangePicker
        label="Abertura"
        date-limit="fromToday"
        :value="filters.abertura"
        @input="updateAndCommit('abertura', $event)"
      />
    </div>
    <div class="column filtros-licitacoes__campo is-12-mobile is-6-tablet is-2-desktop">
      <DateRangePicker
        label="Publicação"
        date-limit="untilToday"
        :value="filters.publicacao"
        @input="updateAndCommit('publicacao', $event)"
      />
    </div>
    <div class="column filtros-licitacoes__campo is-12-mobile is-6-tablet is-3-desktop">
      <b-field label="Nº Licitação/Processo">
        <b-input
          placeholder="Nº do processo ou da licitação"
          :value="filters.processoOuNumero"
          @input="update('processoOuNumero', $event)"
          @blur="commit"
        />
      </b-field>
    </div>
    <div class="column filtros-licitacoes__campo is-12-mobile is-6-tablet is-2-desktop">
      <FiltroMultiSelect
        label="Modalidade"
        :options="modalidades"
        :value="filters.modalidades"
        @input="update('modalidades', $event)"
        @commit="commit"
        @open="$emit('open')"
        @close="$emit('close')"
      />
    </div>
    <div class="column filtros-licitacoes__campo is-12-mobile is-6-tablet is-3-desktop">
      <FiltroMultiSelect
        label="Tipo de Edital"
        :options="tiposEdital"
        :value="filters.tiposEdital"
        @input="update('tiposEdital', $event)"
        @commit="commit"
        @open="$emit('open')"
        @close="$emit('close')"
      />
    </div>
    <div class="column filtros-licitacoes__campo is-12-mobile is-6-tablet is-3-desktop">
      <FiltroMultiSelect
        label="Tipo de Pregão"
        :options="tiposPregao"
        :value="filters.tiposPregao"
        @input="update('tiposPregao', $event)"
        @commit="commit"
        @open="$emit('open')"
        @close="$emit('close')"
      />
    </div>
    <div class="column filtros-licitacoes__campo is-12-mobile is-6-tablet is-4-desktop">
      <FiltroTextoTodos
        label="Objeto"
        placeholder="Descrição do objeto"
        :show-todos-tag="false"
        :value="filters.objeto"
        @input="update('objeto', $event)"
        @blur="commit"
      />
    </div>
  </div>
</template>

<script>
import DateRangePicker from '@/components/DateRangePicker/DateRangePicker';
import FiltroMultiSelect from './FiltroMultiSelect';
import FiltroTextoTodos from './FiltroTextoTodos';

const UNASSIGNED_UNIT_ID = '__unassigned__';

export default {
  name: 'FiltrosLicitacoesPregoeiro',
  components: { DateRangePicker, FiltroMultiSelect, FiltroTextoTodos },
  props: {
    value: { type: Object, required: true },
    situacoes: { type: Array, required: true },
    modalidades: { type: Array, required: true },
    tiposEdital: { type: Array, required: true },
    tiposPregao: { type: Array, required: true },
    purchasingUnits: { type: Array, default: () => [] },
    purchasingUnitsLoading: { type: Boolean, default: false },
  },
  computed: {
    filters() {
      return this.value;
    },
    purchasingUnitOptions() {
      const options = this.purchasingUnits.map(unit => {
        const virtual =
          unit.virtual ||
          unit.unassigned ||
          unit.id == null ||
          String(unit.id).toUpperCase() === 'UNASSIGNED' ||
          String(unit.name || '')
            .trim()
            .toLowerCase() === 'unidade não definida';
        return virtual
          ? { ...unit, id: UNASSIGNED_UNIT_ID, label: 'Unidade não definida', virtual: true }
          : { ...unit, label: `${unit.code || ''} — ${unit.name || ''}`.trim() };
      });
      return options.some(option => option.id === UNASSIGNED_UNIT_ID)
        ? options
        : [...options, { id: UNASSIGNED_UNIT_ID, label: 'Unidade não definida', virtual: true }];
    },
    selectedUnitFilterValues() {
      return this.filters.purchasingUnitUnassigned
        ? [...this.filters.purchasingUnitIds, UNASSIGNED_UNIT_ID]
        : this.filters.purchasingUnitIds;
    },
  },
  methods: {
    update(key, value) {
      this.$emit('input', { ...this.value, [key]: value });
    },
    updateAndCommit(key, value) {
      this.update(key, value);
      this.$nextTick(() => this.commit());
    },
    updateUnitFilters(values) {
      const selectedValues = Array.isArray(values) ? values : [];
      const unassigned = selectedValues.includes(UNASSIGNED_UNIT_ID);
      const purchasingUnitIds = selectedValues.filter(value => value !== UNASSIGNED_UNIT_ID);
      this.$emit('input', {
        ...this.value,
        purchasingUnitIds,
        purchasingUnitUnassigned: unassigned,
      });
    },
    commit() {
      this.$emit('commit');
    },
  },
};
</script>
